import countChecked from './CountChecked';
import GermanNumberFormat from '../NumberUtil';

const startDate: string = 'July 22, 2019 00:00:00';
const checked: number = countChecked(startDate, new Date().toString());
const getCountChecked = (): string => GermanNumberFormat(checked);

export default getCountChecked;
